import { Application, Container, Ticker } from "pixi.js";
import * as Tweedle from 'tweedle.js';
import GameBackground from "./components/GameBackground";
import { IScene } from "./scripts/types";

export const SCREEN_WIDTH = 800;
export const SCREEN_HEIGHT = 600;

export class Manager {
  private constructor() { }
  private static app: Application;
  private static currentScene: IScene;

  public static background: GameBackground;

  public static get scene(): IScene {
    return Manager.currentScene;
  }

  public static get stage(): Container {
    return Manager.app.stage;
  }

  public static async initialize(): Promise<Application> {
    Manager.app = new Application({
      view: document.getElementById("pixi-canvas") as HTMLCanvasElement,
      resolution: window.devicePixelRatio || 1,
      autoDensity: true,
      backgroundColor: 'black',
      width: SCREEN_WIDTH,
      height: SCREEN_HEIGHT,
    });
    Manager.app.ticker.minFPS = 30;
    Manager.app.ticker.maxFPS = 60;
    Manager.app.ticker.add(Manager.update);
    Manager.app.ticker.add(() => Tweedle.Group.shared.update(Ticker.shared.elapsedMS), this);
    Manager.background = await GameBackground.makeBackground();
    Manager.app.stage.addChild(this.background);
    
    // Адаптивное масштабирование
    window.addEventListener('resize', Manager.resize);
    Manager.resize();
    
    return Manager.app;
  }

  private static resize(): void {
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;
    
    // Изменяем размер renderer под размер окна
    Manager.app.renderer.resize(screenWidth, screenHeight);
    
    // Обновляем позицию и размер фона
    if (Manager.background) {
      Manager.background.position.set(screenWidth / 2, screenHeight / 2);
      Manager.background.width = screenWidth;
      Manager.background.height = screenHeight;
    }
    
    // Масштабируем и центрируем текущую сцену (игровое поле)
    if (Manager.currentScene) {
      const scale = Math.min(
        screenWidth / SCREEN_WIDTH,
        screenHeight / SCREEN_HEIGHT
      );
      Manager.currentScene.scale.set(scale);
      Manager.currentScene.position.set(screenWidth / 2, screenHeight / 2);
      Manager.currentScene.pivot.set(SCREEN_WIDTH / 2, SCREEN_HEIGHT / 2);
    }
  }

  public static async changeScene(newScene: IScene): Promise<void> {
    if (Manager.currentScene) {
      await Manager.currentScene.onLeave();
      Manager.app.stage.removeChild(Manager.currentScene);
      Manager.currentScene.destroy();
    }
    Manager.currentScene = newScene;
    Manager.app.stage.addChild(Manager.currentScene);
    Manager.resize();
    await Manager.currentScene.onEnter();
  }

  public static getApp(): Application {
    return Manager.app;
  }

  private static update(delta: number): void {
    if (Manager.currentScene) Manager.currentScene.update(delta);
  }
}
